export default {

    apiGetOverallMetrics(data, urldata = {}) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_OVERALL_METRICS, payload)
            .urltransform(urldata)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetPortfolioMetricsDigirep(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_PORTFOLIO_METRICS_DIGIREP, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetPortfolioMetricsLeads(data, urldata = {}) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_PORTFOLIO_METRICS_LEADS, payload)
            .urltransform(urldata)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetPortfolioMetricsPayment(data, urldata = {}) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_PORTFOLIO_METRICS_PAYMENT, payload)
            .urltransform(urldata)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetProductMetrics(data, urldata = {}) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_PRODUCT_METRICS, payload)
            .urltransform(urldata)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetStateMetrics(data, urldata = {}) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_STATE_METRICS, payload)
            .urltransform(urldata)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },
}